import { useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { isAuth, restoreSession } from "../helper/auth";
import Sidebar from "../component/Admin/SidebarAdmin";
import DashboardAdmin from "../page/Admin/DashboardAdmin";
import Users from "../page/Admin/Users";
import Devisi from "../page/Admin/Devisi";
import Status from "../page/Admin/Status";
import DetailUser from "../page/Admin/DetailUser";
import Admin from "../page/Admin/Admin";
import ReportUser from "../page/Admin/ReportUser";
import HariLibur from "../page/Admin/HariLibur";
import Lokasi from "../page/Admin/Lokasi";
import ScrollToTop from "../component/common/ScrollToTop";

const AdminLayout = () => {
    const [user, setUser] = useState(() => isAuth());
    const [ready, setReady] = useState(() => !!isAuth());

    useEffect(() => {
        let cancelled = false;
        (async () => {
            let u = isAuth();
            if (!u) u = await restoreSession();
            if (!cancelled) {
                setUser(u);
                setReady(true);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    if (!ready) {
        return <div className="min-h-screen bg-zafu-cream" />;
    }

    if (user?.role !== "admin") {
        return <Navigate to="/login-admin" />;
    }

    const data = {
        user: {
            id: user?.id,
            username: user?.username,
            nama: user?.nama,
            email: user?.email,
        },
    };

    return (
        <div>
            <Sidebar />
            <div className="overflow-x-hidden md:ml-64 bg-zafu-cream min-h-screen">
                <ScrollToTop />
                <div className="md:m-4 m-2 md:p-2">
                    <Routes>
                        <Route path="/" element={<DashboardAdmin data={data} />} />
                        <Route path="/dashboard" element={<DashboardAdmin data={data} />} />
                        <Route path="/users" element={<Users data={data} />} />
                        <Route path="/users/detail/:id_user" element={<DetailUser data={data} />} />
                        <Route path="/users/report/:id_user" element={<ReportUser data={data} />} />
                        <Route path="/status/" element={<Status data={data} />} />
                        <Route path="/devisi" element={<Devisi data={data} />} />
                        <Route path="/lokasi" element={<Lokasi data={data} />} />
                        <Route path="/hari-libur" element={<HariLibur data={data} />} />
                        <Route path="/admin" element={<Admin data={data} />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default AdminLayout;
